import { FC } from 'react'
import { Page, MainContent, Content } from './styled-components'
import { ThemeProvider } from 'styled-components'
import themes from 'themes'
import { RootState } from 'data/store'
import { connect } from 'react-redux'
import { PageProps } from './types'
import { useQuery } from 'hooks'

const mapStateToProps = ({
  user: { address }
}: RootState) => ({
  address
})
type ReduxType = ReturnType<typeof mapStateToProps>

const PageComponent: FC<PageProps & ReduxType> = ({
  children
}) => {
  const queryParams = useQuery()
  const config = queryParams.get('theme') || 'light'
  const currentTheme = themes(config).light
  
  return <ThemeProvider theme={currentTheme}>
    <Page>
      <MainContent>
        <Content>
          {children}              
        </Content>
      </MainContent>
    </Page>
  </ThemeProvider>
}


export default connect(mapStateToProps)(PageComponent)
